import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ColorCircleProps {
  className?: string;
  width?: number;
  height?: number;
  onClick: (color: string) => void;
  color: string;
  isSelected?: boolean;
}

const ColorCircleIcon = function ColorCircleIcon({
  className,
  width,
  height,
  onClick,
  color,
  isSelected,
}: ColorCircleProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge(className, 'cursor-pointer')}
      width={width}
      height={height}
      onClick={() => onClick(color)}
      viewBox="0 0 40 40"
    >
      <circle className={twMerge('fill-transparent', className)} cx="20" cy="20" r="19" stroke={isSelected ? '#DADADA' : ''} strokeWidth="2" />
      <circle cx="20" cy="20" r="16" fill={color} />
      {isSelected && <path fill="transparent" d="M12 19.5L18 25L28 14" stroke="#EAEBED" strokeWidth="2" strokeLinecap="round" />}
    </svg>
  );
};

ColorCircleIcon.defaultProps = {
  className: '',
  width: 40,
  isSelected: false,
  height: 40,
};

export default ColorCircleIcon;
